import { ZodSchema, ZodTypeDef } from 'zod/v3';

/**
 * Allowing empty string as a default value regardless of output type because empty HTML input elements mostly return empty string
 */

export const transformNull = <
  O,
  I = O,
  S extends ZodSchema<O, ZodTypeDef, I | null> = ZodSchema<
    O,
    ZodTypeDef,
    I | null
  >,
>(
  schema: S,
  defaultValue: O,
) => schema.nullable().transform<O>((v) => (v === null ? defaultValue : v));
